import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { FormGroup } from "semantic-ui-react";
import { Button, Modal, ControlLabel, FormControl } from "react-bootstrap";
import _ from "lodash";
import { customLog } from "../../variables/Variables";

// Css
import "../../assets/css/grantaccesstables.css";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    recipientNameHeader: "Lock Name",
    recipientEmailHeader: "Lock Type",
    selectRecipientBtn: "Select Lock",
    editRecipientBtn: "Edit Lock",
    popUpTitle: "Locks",
    selectRecipientsLabel: "Select Lock",
    nameHeader: "Name",
    emailHeader: "Type",
    recipientListLabel: "Lock List",
    okBtn: "OK",
    cancelBtn: "Cancel",
    noDataTitle: "There is no data to display",
    searchPlaceholder: "Search",
  },
  ja: {
    recipientNameHeader: "メンバー名",
    recipientEmailHeader: "メンバーEmail",
    selectRecipientBtn: "メンバー選択",
    editRecipientBtn: "メンバー編集",
    popUpTitle: "メンバー",
    selectRecipientsLabel: "メンバー選択",
    nameHeader: "名前",
    emailHeader: "Eメール",
    recipientListLabel: "メンバーリスト",
    okBtn: "OK",
    cancelBtn: "キャンセル",
    noDataTitle: "表示するデータがありません。",
    searchPlaceholder: "検索",
  },
  es: {
    recipientNameHeader: "Nombre de la Candado",
    recipientEmailHeader: "Tipo de Candado",
    selectRecipientBtn: "Seleccionar Candado",
    editRecipientBtn: "Editar Candado",
    popUpTitle: "Candados",
    selectRecipientsLabel: "Seleccionar Candado",
    nameHeader: "Nombre",
    emailHeader: "Tipo",
    recipientListLabel: "Lista de Candados",
    okBtn: "OK",
    cancelBtn: "Cancelar",
    noDataTitle: "No hay datos para mostrar",
    searchPlaceholder: "Buscar",
  },
});

class LocksTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPopup: false,
      locklistArray: [],
      addedLock: [],
      selectedLock: [],
      fullLockList: [],
    };

    this.handleInsertButtonClick = this.handleInsertButtonClick.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.createCustomSearchFieldForm = this.createCustomSearchFieldForm.bind(
      this
    );
    this.renderSelectLock = this.renderSelectLock.bind(this);
    this.unselectLock = this.unselectLock.bind(this);
    this.handlePopupSubmit = this.handlePopupSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      {
        locklistArray: this.state.fullLockList, // Add all locks back to locklistArray if 'Clear' button is clicked
      },
      () => {
        this.setState({
          selectedLock: nextProps.selectedLock,
          addedLock: nextProps.selectedLock,
          locklistArray: this.state.locklistArray.filter(
            (lock) =>
              !nextProps.selectedLock.some(
                (selectedLock) => selectedLock.id === lock.id
              )
          ),
        });
      }
    );
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        const snapshotVal = snapshot.val();
        // customLog(snapshotVal);
        let lockArrayWithShareRights = [];
        let lockDetails = {};
        let snapId = {};
        for (const eachLockId in snapshotVal) {
          if (
            snapshotVal[eachLockId].sharedBy === "" ||
            snapshotVal[eachLockId].sharePermissionType === 1
          ) {
            const currTimeStamp = Math.floor(Date.now() / 1000);

            if (
              snapshotVal[eachLockId].sharedBy !== "" &&
              snapshotVal[eachLockId].shareStartTime > 0 &&
              snapshotVal[eachLockId].shareEndTime > 0 &&
              (snapshotVal[eachLockId].shareStartTime > currTimeStamp ||
                snapshotVal[eachLockId].shareEndTime < currTimeStamp)
            ) {
            } else {
              snapId = { snapId: eachLockId };
              lockDetails = {
                ...snapshotVal[eachLockId],
                ...snapId,
              };
              lockArrayWithShareRights.push(lockDetails);
            }
          }
        }

        this.setState({
          locklistArray: lockArrayWithShareRights,
          fullLockList: lockArrayWithShareRights,
          loading: false,
        });
        // }
      })
      .catch((err) => {
        customLog(err);
      });
  }

  createCustomInsertButton = (onClick) => {
    return (
      <button
        className="selectlockbutton"
        onClick={() => this.handleInsertButtonClick(onClick)}
      >
        <i className="fa fa-lock" />{" "}
        {this.state.selectedLock.length > 0
          ? localizationStrings.editRecipientBtn
          : localizationStrings.selectRecipientBtn}
      </button>
    );
  };
  getLockModelName(type) {
    let lock = "Lock Model Unknown";
    if (type === 1) {
      lock = "Debossed Lock";
    } else if (type === 2) {
      lock = "TSA Travel Lock";
    } else if (type === 3) {
      lock = "Padlock with NFC and Bluetooth";
    } else if (type === 4) {
      lock = "IP45 Padlock";
    } else if (type === 10) {
      lock = "IP66 Padlock";
    } else if (type === 7 || type === 8 || type === 9) {
      lock = "Lock Out Tag Out";
    } else if (type === 11) {
      lock = "Anti-Cut Padlock";
    } else if (type === 12) {
      lock = "Heavy Duty Padlock";
    } else if (type === 13) {
      lock = "IP66 LOTO";
    }
    // IP45 Padlock

    return lock;
  }
  //   handleInsertButtonClick() {
  //     const allLocks = [];
  //     const selectedLock = [];

  //     for (let b = 0; b < this.state.locklistArray.length; b++) {
  //         allLocks.push(this.state.locklistArray[b]);
  //     }

  //     for (let b = 0; b < this.state.locklistArray.length; b++) {
  //         const eachSelectedLock = this.state.locklistArray[b];
  //         selectedLock.push(eachSelectedLock);
  //     }

  //     console.log(this.state.locklistArray.map(lock => ({ Name: lock.Name, Type: lock.Type })));

  //     this.setState({
  //         showPopup: true,
  //         LockListArray: allLocks,
  //         selectedLock: selectedLock,
  //     });
  // }

  handleInsertButtonClick() {
    const allLocks = [...this.state.locklistArray];
    const selectedLock = [...this.state.selectedLock];

    this.setState({
      showPopup: true,
      initialLocklistArray: allLocks,
      initialAddedLock: selectedLock,
    });
  }

  // handlePopupClose() {
  //   const addedLockArray = [];
  //   const allLockArray = this.state.locklistArray.filter(lock =>
  //     !this.state.selectedLock.some(selectedLock => selectedLock.snapId === lock.snapId)
  //   );

  //   for (var i = 0; i < this.state.selectedLock.length; i++) {
  //     const eachSelectedLock = this.state.selectedLock[i];

  //     addedLockArray.push(eachSelectedLock);
  //   }

  //   this.setState({
  //     showPopup: false,
  //     addedLock: addedLockArray,
  //     locklistArray: allLockArray,
  //   });
  // }

  handlePopupClose(cancelled = false) {
    if (cancelled) {
      this.setState({
        showPopup: false,
        locklistArray: [...this.state.initialLocklistArray],
        addedLock: [...this.state.initialAddedLock],
        selectedLock: [...this.state.initialAddedLock],
      });
    } else {
      this.setState({
        showPopup: false,
        addedLock: [...this.state.initialAddedLock],
        locklistArray: [...this.state.initialLocklistArray],
        selectedLock: [...this.state.initialAddedLock],
      });
    }
  }

  createCustomSearchFieldForm() {
    return (
      <SearchField
        // style={{ color: "blue" }}
        className="formSearchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  }
  renderSelectLock(cell, row) {
    return (
      <div>
        <button
          className={"select-btn"}
          onClick={(e) => {
            e.preventDefault();

            const allLockArrayList = this.state.locklistArray;
            const addedLockArrayList = this.state.addedLock;

            addedLockArrayList.push(row);
            allLockArrayList.splice(allLockArrayList.indexOf(row), 1);
            this.setState({
              locklistArray: allLockArrayList,
              addedLock: addedLockArrayList,
            });
            // console.log(addedLockArrayList)
          }}
        >
          <span className="plusIcon">&#43;</span>
        </button>
      </div>
    );
  }

  unselectLock(cell, row) {
    return (
      <div>
        <button
          className={"unselect-btn"}
          onClick={(e) => {
            e.preventDefault();

            const allLockArrayList = this.state.locklistArray;
            const addedLockArrayList = this.state.addedLock;

            allLockArrayList.push(row);
            addedLockArrayList.splice(addedLockArrayList.indexOf(row), 1);

            this.setState({
              locklistArray: allLockArrayList,
              addedLock: addedLockArrayList,
            });
          }}
        >
          <span className="crossIcon">&times;</span>
        </button>
      </div>
    );
  }

  handlePopupSubmit() {
    const confirmedLock = [];

    for (var i = 0; i < this.state.addedLock.length; i++) {
      const eachAddedLock = this.state.addedLock[i];

      confirmedLock.push(eachAddedLock);
    }

    this.props.dataCallBack(confirmedLock);

    this.setState({
      showPopup: false,
      selectedLock: confirmedLock,
    });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        {this.props.visible && (
          <BootstrapTable
            className="grantAccessSelectTable"
            data={this.state.selectedLock}
            bordered={false}
            pagination
            options={{
              sizePerPage: 5,
              hideSizePerPage: true,
              insertBtn: this.createCustomInsertButton,
              noDataText: localizationStrings.noDataTitle,
            }}
            insertRow
            tableStyle={{ border: "4px solid #3C3E41", borderRadius: "12px" }}
          >
            <TableHeaderColumn
              dataField="Name"
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              {localizationStrings.recipientNameHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="Type"
              dataFormat={this.getLockModelName}
              isKey={true}
              tdStyle={{ textAlign: "center" }}
              thStyle={{ textAlign: "center" }}
            >
              {localizationStrings.recipientEmailHeader}
            </TableHeaderColumn>
          </BootstrapTable>
        )}
        {/* //! Popup for Select Recipient Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-70w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.popUpTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <div className="selectMembersTable">
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {/* change */}
                {localizationStrings.selectRecipientsLabel}
              </ControlLabel>
              <BootstrapTable
                data={this.state.locklistArray}
                bordered={false}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  searchField: this.createCustomSearchFieldForm,
                  defaultSortName: "Name", // default sort column name
                  defaultSortOrder: "asc", // default sort order
                  noDataText: localizationStrings.noDataTitle,
                }}
                search
              >
                <TableHeaderColumn
                  // dataSort
                  dataField="Name"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="Type"
                  dataFormat={this.getLockModelName}
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.emailHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataFormat={this.renderSelectLock}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                ></TableHeaderColumn>
              </BootstrapTable>
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.recipientListLabel}
              </ControlLabel>
              <BootstrapTable
                data={this.state.addedLock}
                bordered={false}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  noDataText: localizationStrings.noDataTitle,
                }}
              >
                <TableHeaderColumn
                  // dataSort
                  dataField="Name"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="Type"
                  dataFormat={this.getLockModelName}
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.emailHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataFormat={this.unselectLock}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                ></TableHeaderColumn>
              </BootstrapTable>
            </div>
            <FormGroup style={{ display: "flex" }}>
              <Button
                style={{ marginRight: "10px" }}
                onClick={this.handlePopupSubmit}
              >
                {localizationStrings.okBtn}
              </Button>
              <Button
                style={{ marginLeft: "10px" }}
                onClick={this.handlePopupClose}
              >
                {localizationStrings.cancelBtn}
              </Button>
            </FormGroup>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default LocksTable;
